import { render, staticRenderFns } from "./BaseCloseButton.vue?vue&type=template&id=6942f0b6&scoped=true&lang=pug"
import script from "./BaseCloseButton.vue?vue&type=script&lang=ts"
export * from "./BaseCloseButton.vue?vue&type=script&lang=ts"
import style0 from "./BaseCloseButton.vue?vue&type=style&index=0&id=6942f0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942f0b6",
  null
  
)

export default component.exports